var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 567,
    height: 10,
    viewBox: "0 0 567 10",
    fill: "#EF4637",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375.758 0.441406C383.475 0.454162 410.812 0.620005 428.339 0.594493C468.89 0.530712 509.455 0.568963 549.905 1.51292C556.232 1.66599 566.972 1.67876 566.755 4.5744C566.526 7.57209 559.331 9.31969 548.31 9.20489C521.624 8.9115 494.798 8.19715 468.24 8.7074C429.397 9.44725 390.606 9.00078 351.802 9.1411C316.952 9.25591 282.102 9.07732 247.252 9.21764C214.52 9.3452 181.801 9.983 149.081 9.93198C120.839 9.89371 92.6097 9.12834 64.3676 8.83495C57.7217 8.77117 49.7108 9.29418 42.4271 9.24315C36.3934 9.20488 26.3416 9.1666 20.3717 8.91148C17.795 8.79668 15.1162 8.65636 12.5905 8.77116C0.982403 9.2559 -2.07907 8.20991 1.81155 4.91882C2.66621 4.19172 1.68399 3.24775 4.49034 2.75026C4.60514 2.72475 4.83475 2.68649 4.94956 2.66098C13.4579 0.671024 22.1831 1.60222 30.9721 1.56395C74.1133 1.37261 117.267 1.3726 160.409 1.29607C186.878 1.2578 213.385 1.39813 239.816 1.0282C247.048 0.926148 254.294 0.505187 261.629 0.76031H261.501C269.167 0.658261 276.834 0.479686 284.488 0.492442C313.482 0.543466 343.753 0.30109 371.561 0.581725C372.671 0.568968 374.15 0.441406 375.758 0.441406Z",
    fill: "#4633FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/Underline.726ab12c23e6ea9655a3e20a030ab87d.svg";
export { ForwardRef as ReactComponent };